import React from "react";
import { VideoFormat } from "types/api";

type CinemagraphProps = {
  width: number;
  height: number;
  formats: VideoFormat[];
  poster?: { url: string };
  className?: string;
};

const Cinemagraph = ({
  width,
  height,
  formats,
  poster,
  className,
}: CinemagraphProps) => {
  // Sort H264 to be last since it's the slowest
  // without double-sorting other encodings, HVEC & VP9
  if (formats[formats.length - 1].encoding !== "H264") {
    formats?.sort((a) => {
      return a.encoding === "H264" ? 1 : -1;
    });
  }
  return (
    <video
      className={className}
      width={width}
      height={height}
      autoPlay={true}
      loop={true}
      muted={true}
      playsInline={true}
      poster={poster && poster.url}
    >
      {formats.map((format) => {
        return (
          format?.encoding &&
          format.url && (
            <source
              key={`lead-art-${format.encoding}`}
              src={format.url}
              type={
                (format.encoding === "H264" && "video/mp4; codecs=avc1") ||
                (format.encoding === "VP9" && "video/webm; codecs=vp9") ||
                (format.encoding === "HEVC" && "video/mp4; codecs=hvc1") ||
                ""
              }
            />
          )
        );
      })}
    </video>
  );
};

export default Cinemagraph;
